import { TenantProvider } from "@/context/TenantContext";
import { useTenant } from "@/context/useTenant";
import { RouterProvider } from "@tanstack/react-router";
import { getRouter } from "@/project/router";

// Instantiate the router once outside the render cycles to ensure stability
const router = getRouter();

function App() {
  return (
    <TenantProvider>
      <AppWithRouter />
    </TenantProvider>
  );
}

const AppWithRouter = () => {
  const { tenantId } = useTenant();

  // If no tenant ID is available, show a tenant selection page
  if (!tenantId) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="mb-4 text-2xl font-bold">Tenant ID Required</h1>
          <p className="text-gray-600">
            Please set the VITE_X_TENANTID environment variable.
          </p>
        </div>
      </div>
    );
  }

  return <RouterProvider router={router} />;
};

export default App;
